import {postWithAuth} from '~/code/api'
import {DccSummaryRequestType} from '../models'
import {DccSummaryResponseType} from '../models/DccSummaryResponseType'

export const fetchDccSummary = (requestData: DccSummaryRequestType) =>
    postWithAuth<DccSummaryResponseType>('/oppapi/v1/dcc/summary', requestData)
